// 该模块主要实现对query参数进行的简化
export const sensorHistoryQueryFormat = function (sensorObject) {
  // eslint-disable-next-line camelcase
  const {
    id,
    tagId,
    probe_value,
    scopeName,
    carrierName,
    carrierId,
    carrierType,
    sensorWay,
    description
  } = sensorObject
  return {
    id,
    tagId,
    probe_value,
    scopeName,
    carrierName,
    carrierId,
    carrierTypeId: carrierType,
    sensorWay,
    description
  }
}
